import { JoinFullSharp } from '@mui/icons-material';
import { jwtDecode } from 'jwt-decode';
import { createContext, useEffect, useState } from 'react';

const UserContext = createContext(null);
export default UserContext;

export const UserContextProvider = ({ children }) => {
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const UserContextData = {
    loggedInUser,
    setLoggedInUser,
    isAuthenticated,
    setIsAuthenticated,
  };

  // useEffect(() => {
  //   const token = localStorage.getItem('token');

  //   if (!token) {
  //     setLoggedInUser(null);
  //     setIsAuthenticated(false);
  //   } else {
  //     const decodedToken = jwtDecode(token);

  //     if (decodedToken.id) {
  //       setLoggedInUser({
  //         id: decodedToken.id,
  //         name: decodedToken.username,
  //       });
  //       setIsAuthenticated(true);
  //     } else setLoggedInUser(null);
  //   }
  // }, []);

  useEffect(() => {
    try {
      const token = localStorage.getItem('token');

      if (!token) {
        setLoggedInUser(null);
        setIsAuthenticated(false);
        return;
      }

      const decodedToken = jwtDecode(token);

      if (decodedToken?.id) {
        setLoggedInUser({
          id: decodedToken.id,
          name: decodedToken.username,
        });
        setIsAuthenticated(true);
      } else {
        setLoggedInUser(null);
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error('Error decoding token:', error);
      setLoggedInUser(null);
      setIsAuthenticated(false);
    }
  }, []);

  return (
    <UserContext.Provider value={UserContextData}>
      {children}
    </UserContext.Provider>
  );
};
